import React from 'react';
import AirfieldInfo from '../components/AirfieldInfo';
import StructuredData, { breadcrumbStructuredData } from '../components/StructuredData';
import { usePageMeta } from '../hooks/usePageMeta';

const AirfieldInfoPage: React.FC = () => {
  usePageMeta({
    title: 'Flugplatzinformationen EDEB für UL-Piloten | Flugsportverein Otto Lilienthal',
    description:
      'Sonderlandeplatz Bad Langensalza (EDEB) für UL-Piloten: Graspiste 09/27 (700 × 30 m), Funk 125,365 MHz, Platzrunde, Landegebühr, METAR und Wetter.',
    path: '/flugplatzinfo',
  });

  return (
    <>
      <StructuredData data={breadcrumbStructuredData('Flugplatzinformationen', '/flugplatzinfo')} />
      <AirfieldInfo />
    </>
  );
};

export default AirfieldInfoPage;
